import { DAYS, DAYS_FOR_DOCTOR_SLOTS, ONLY_FREE } from 'www/modules/Schedule/constants'
import type { ScheduleType } from 'www/api/apiScheduleTelemed.types'

/**
 * @description
 * Интерфейсы соответствуют объектам, которые ожидаются на backend.
 * Если передаваемые данные в запросе не соответствуют полям интерфейса - будет ошибка валидации.
 */

export type LpuSpecialityRequestItem = {
  lpu_id: number
  name: string
  translit: string
  speciality_id: number
}

export type LpuRequestInterface = {
  days: number
  dt_start: string | Date | null
  town_timedelta: string | number | null
  lpus_specialities: LpuSpecialityRequestItem[]
}

export const getLpuRequestInterface = (): LpuRequestInterface => ({ // запрос за календарями с выбором специальности(список клиник)
  days: DAYS_FOR_DOCTOR_SLOTS,
  dt_start: '',
  town_timedelta: '',
  lpus_specialities: [],
})

export type DoctorLpuRequestItem = {
  lpu_id: number
  doctor_id: number
  lpu_timedelta?: string
  has_slots?: boolean
  telemed_price?: number | null
  telemed_medtochka_price?: number | null
  doctor_fio?: string
}

export type DoctorRequestInterface = {
  days: number
  dt_start: string | Date | null
  doctors_lpus: DoctorLpuRequestItem[]
  town_timedelta: string | number | null
}

export const getDoctorRequestInterface = (): DoctorRequestInterface => ({ // запрос за календарями врачей
  days: DAYS_FOR_DOCTOR_SLOTS,
  dt_start: '',
  doctors_lpus: [],
  town_timedelta: null,
})

export type DoctorOnlineScheduleParam = {
  doctor_id: number
  type_schedule: ScheduleType
}

export type DoctorOnlineLpuParam = {
  lpu_id: number
  schedule_params: DoctorOnlineScheduleParam[]
}

export type DoctorOnlineRequestInterface = {
  user_start_date: string
  user_timezone: number | null
  days: number
  only_free: boolean
  lpu_params: DoctorOnlineLpuParam[]
}

/**
 * Фабрика payload для apiScheduleTelemed.post.
 *
 * @returns {DoctorOnlineRequestInterface} начальный объект запроса телемеда
 */
export const getDoctorOnlineRequestInterface = (): DoctorOnlineRequestInterface => ({
  user_start_date: '',
  user_timezone: null,
  days: DAYS_FOR_DOCTOR_SLOTS,
  only_free: true,
  lpu_params: [],
})

export type ServiceRequestItem = {
  lpu_id: number | null
  service_id: number
}

export type ServicesRequestInterface = {
  days: number
  services: ServiceRequestItem[]
  day_start: string | Date | null
  only_free: boolean
  town_timedelta: string | number | null
}

export const getServicesRequestInterface = (): ServicesRequestInterface => ({ // запрос за календарями на услугах(запись на синоним)
  days: DAYS,
  services: [],
  day_start: '',
  only_free: ONLY_FREE,
  town_timedelta: null,
})
